export const homeLabel = "Accueil";
